import { render, staticRenderFns } from "./StatisticsInfo.vue?vue&type=template&id=16936bd2"
import script from "./StatisticsInfo.vue?vue&type=script&lang=js"
export * from "./StatisticsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports